module.exports = __webpack_public_path__ + "static/media/sh.50626aa7.svg";